import { render, staticRenderFns } from "./HvTable.vue?vue&type=template&id=2638b91a"
import script from "./HvTable.vue?vue&type=script&lang=js"
export * from "./HvTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports